import SnackbarController from './snackbar.controller';
import './snackbar.css';

const template = require<string>('./snackbar.html');

const snackbarComponent:ng.IComponentOptions = {
  controller: SnackbarController,
  template,
  transclude: {
    action: '?snackbarActionText',
    content: '?snackbarContent',
  }
};
export default snackbarComponent;



/** WEBPACK FOOTER **
 ** ./app/snackbar/snackbar.component.ts
 **/